/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateResellerInvoiceOverviews200ResponseFailuresInner
 */
export interface CreateResellerInvoiceOverviews200ResponseFailuresInner {
    /**
     * 
     */
    resellerName?: string;
    /**
     * 
     */
    spName?: string;
    /**
     * 
     */
    error?: string;
}

/**
 * Check if a given object implements the CreateResellerInvoiceOverviews200ResponseFailuresInner interface.
 */
export function instanceOfCreateResellerInvoiceOverviews200ResponseFailuresInner(value: object): value is CreateResellerInvoiceOverviews200ResponseFailuresInner {
    return true;
}

export function CreateResellerInvoiceOverviews200ResponseFailuresInnerFromJSON(json: any): CreateResellerInvoiceOverviews200ResponseFailuresInner {
    return CreateResellerInvoiceOverviews200ResponseFailuresInnerFromJSONTyped(json, false);
}

export function CreateResellerInvoiceOverviews200ResponseFailuresInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateResellerInvoiceOverviews200ResponseFailuresInner {
    if (json == null) {
        return json;
    }
    return {
        
        'resellerName': json['resellerName'] == null ? undefined : json['resellerName'],
        'spName': json['spName'] == null ? undefined : json['spName'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function CreateResellerInvoiceOverviews200ResponseFailuresInnerToJSON(json: any): CreateResellerInvoiceOverviews200ResponseFailuresInner {
    return CreateResellerInvoiceOverviews200ResponseFailuresInnerToJSONTyped(json, false);
}

export function CreateResellerInvoiceOverviews200ResponseFailuresInnerToJSONTyped(value?: CreateResellerInvoiceOverviews200ResponseFailuresInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resellerName': value['resellerName'],
        'spName': value['spName'],
        'error': value['error'],
    };
}

